// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.distanceLabel .el-form--label-top .el-form-item__label {\n  white-space: nowrap !important;\n}\n", ""]);
// Exports
module.exports = exports;
